<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_2"></a>Author’s foreword</h2>
<p class="para">Whatever a garden’s size, many home gardeners repeatedly yearn for a larger area where, perhaps, a wider range of plants can be grown. Yet it can be just as satisfying to accept a small garden and to cultivate it intensively and in an inspirational way.</p>
<p class="indent-para">By their nature, small gardens sometimes have the bonus of creating unforeseen gardening possibilities; whereas in a large area gardening is mainly at ground level, in small spaces vertical as well as overhead gardening become considerations. Wall shrubs are ideal for clothing walls, while climbers are superb for walls, arches and romantic arbors.</p>
<p class="indent-para">Attractive paths help to unify even the smallest garden, and if the area is exceptionally small a patio or courtyard for growing plants in containers can be an answer to creating color throughout the year. Indeed, container gardening with hanging baskets, window boxes, wall baskets, tubs and pots is an inspirational yet practical and popular way to garden.</p>
<p class="indent-para">Many shrubs and small trees have small-garden qualities, including being diminutive or growing only slowly. Additionally, they have varied seasonal interests, whether from flowers, leaves, berries or their bark. Being easy to establish and not having an invasive nature are two other useful qualities. Plants with these attributes are described and recommended in this all-color, detailed and abundantly illustrated book.</p>
<p class="indent-para">With this book by your side, no small garden need be left bare and neglected. There are exciting and colorful possibilities within every garden, whatever its size or shape.</p>
<p class="image"><a id="imgf0002-01"><img alt="Illustration" src="images/f0002-01.jpg"/></a></p><a id="imgf0002-01">
<div class="grey-dgrey">
<h3 class="h3c"><em>Plant names</em></h3>
<p class="paras">Currently recommended botanical names for plants are given throughout this book. Additionally, where earlier and perhaps better known botanical names are still used, these too are included so that you will instantly know the plants being discussed.</p>
<h3 class="h3c">Measurements</h3>
<p class="paras">Both metric and US measurements are given throughout this book – for example, 6 ft (1.8 m).</p>
</div>
<div class="blue-sblue">
<h3 class="h3a">SEASONS</h3>
<p class="para">Throughout this book, advice is given about seasonal tasks. Because of global and even regional variations in climate and temperature, the four main seasons have been used, with each subdivided into “early,” “mid-” and “late” – for example, early spring, mid-spring and late spring. These 12 divisions of the year can be applied tothe appropriate calendar months in your local area, if you find this helps.</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?01877bee